import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/81164d3ba0f00c2a7e247a9f180c9b75/de152bcca179c84c1b093f52431caded.png"
              alt="Robin J. Peterson Company, LLC"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-gray-400 mb-4">
              Representing injured workers throughout Northeast Ohio with dedication and expertise.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-teal-600 transition-colors"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-teal-600 transition-colors"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-teal-600 transition-colors"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">Practice Areas</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/workers-compensation-overview"
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
                >
                  Workers Compensation
                </Link>
              </li>
              <li>
                <Link
                  to="/workplace-injury-types"
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
                >
                  Workplace Injuries
                </Link>
              </li>
              <li>
                <Link
                  to="/workers-compensation-appeals"
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
                >
                  Appeals
                </Link>
              </li>
              <li>
                <Link
                  to="/industrial-injury-lawyer"
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
                >
                  Industrial Injuries
                </Link>
              </li>
              <li>
                <Link
                  to="/repetitive-strain-injury-lawyer"
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
                >
                  Repetitive Strain
                </Link>
              </li>
              <li>
                <Link
                  to="/psychological-injury-lawyer"
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
                >
                  Psychological Injuries
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/case-results"
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
                >
                  Case Results
                </Link>
              </li>
              <li>
                <Link
                  to="/testimonials"
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
                >
                  Testimonials
                </Link>
              </li>
              <li>
                <Link
                  to="/service-areas"
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
                >
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">Contact</h3>
            <div className="space-y-4">
              <div>
                <p className="text-sm font-medium text-white mb-1">Independence Office</p>
                <p className="text-sm text-gray-400">6060 Rockside Woods Blvd. N.</p>
                <p className="text-sm text-gray-400">Suite 200</p>
                <p className="text-sm text-gray-400">Independence, OH 44131</p>
                <a
                  href="https://maps.google.com/?q=6060+Rockside+Woods+Blvd+N+Suite+200+Independence+OH+44131"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-teal-400 hover:text-teal-300 transition-colors inline-block mt-1"
                >
                  Get Directions →
                </a>
              </div>
              <div>
                <p className="text-sm font-medium text-white mb-1">Cuyahoga Falls Office</p>
                <p className="text-sm text-gray-400">265 Portage Trail Extension West</p>
                <p className="text-sm text-gray-400">Suite 100</p>
                <p className="text-sm text-gray-400">Cuyahoga Falls, OH 44223</p>
                <a
                  href="https://maps.google.com/?q=265+Portage+Trail+Extension+West+Suite+100+Cuyahoga+Falls+OH+44223"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-teal-400 hover:text-teal-300 transition-colors inline-block mt-1"
                >
                  Get Directions →
                </a>
              </div>
              <a
                href="tel:2166429007"
                className="text-lg font-semibold text-white hover:text-teal-400 transition-colors inline-block"
              >
                216-642-9007
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>&copy; 2026 Robin J. Peterson Company, LLC. All rights reserved.</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="hover:text-teal-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-teal-400 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
